module.exports = __webpack_public_path__ + "static/media/user3.60b94c62.jpg";